var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--\n  ';
 /*
     including styles inline because these styles are tightly coupled to the JS logic around showing/hiding the correct elements in the list
       a nice refactor would be to encapsulate the general pattern of the following behavior into a component and it's styles, rather than specific to voice keywords:
       * have a delete action next to each item except the last item
       * if you are at the max allowed items:
           * hide the add button
           * also show the delete action next to the last item
  */ 
__p+='\n -->\n<style>\n  .max-keywords-msg {\n    display: none;\n  }\n\n  .max-keywords .max-keywords-msg {\n    display: inline;\n  }\n\n  .max-keywords .keywords-list .add-list__add-another {\n    display: none;\n  }\n\n  /* hide the delete link from the keyword if only one left */\n  .keywords-list .add-list__item:only-child .add-list__close {\n    display: none;\n  }\n</style>\n\n<div data-mount="keywords-list" class="keywords-list"></div>\n<div class="max-keywords-msg color-error">Only '+
((__t=( MAX_KEYWORDS ))==null?'':__t)+
' words or phrases can be identified on calls.</div>\n';
}
return __p;
};
